export const TRANSLATION_KEYS = {
  somethingWentWrong: 'auth-history-something-went-wrong',
  selectFromToDates: 'auth-history-select-from-to-dates',
  invalidRange: 'auth-history-invalid-range',
  reportTitle: 'auth-history-report-title',
  loadReport: 'auth-history-load-report',
  noRecordsFound: 'auth-history-no-records-found',
  colDate: 'auth-history-col-date',
  colDeviceInfo: 'auth-history-col-device-type',
  lastLogin: 'auth-history-last-login',
  loginsCount: 'auth-history-logins-count',
};

export const SERVER_ERROR_MESSAGE_KEYS = {
  'from and to query params are required': TRANSLATION_KEYS.selectFromToDates,
  'from and to must be in yyyy-mm-dd format': TRANSLATION_KEYS.invalidRange,
};

export const LOGIN_TABLE_COLUMNS = 'createdAtView.deviceInfoView';
